import React, { useEffect } from "react";
import "../styles/sharebox.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchCompleteFloridaManDailyProblemCreationAsync } from "./gameSlice";

function ShareBox() {
  const dispatch = useDispatch();

  const { daily } = useSelector((state) => state.game);

  useEffect(() => {
    if (daily.length === 0) {
      dispatch(fetchCompleteFloridaManDailyProblemCreationAsync());
    }
  }, [daily, dispatch]);

  // Safeguard against rendering without data
  if (daily.length < 3) {
    return <div>Loading...</div>; // You can customize this placeholder
  }

  return (
    <div className="outersharecontainer">
      <span className="share-indicator">The Daily 3</span>
      <div className="shareContainer">
        <div style={{ position: "relative", top: 10 }}>
          <h3>Congrats you are off with a misdemeanor!</h3>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div className="small-container">
            <img
              src={daily[0].img}
              alt="mugshot 1"
              style={{
                width: "100px",
                height: "120px",
                objectFit: "cover",
                objectPosition: "50% 50%",
              }}
            />
          </div>
          <div className="small-container">
            <img
              src={daily[1].img}
              alt="mugshot 2"
              style={{
                width: "100px",
                height: "120px",
                objectFit: "cover",
                objectPosition: "50% 50%",
              }}
            />
          </div>
          <div className="small-container">
            <img
              src={daily[2].img}
              alt="mugshot 3"
              style={{
                width: "100px",
                height: "120px",
                objectFit: "cover",
                objectPosition: "50% 50%",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShareBox;
